import { defineEffect } from '../../../core/effect';
import { chainingSpec } from '../fx/chaining';

/** 発動（手札・墓地・除外・デッキから）（Issue #589。状況は共通側の `editorPorts/duelSituations/chaining.js` が決め、絵の組み立ては `../fx/chaining.js`） */
export default defineEffect({ situation: 'chaining_elsewhere', role: 'effect', ...chainingSpec(false) }, 'chaining_elsewhere_effect.js');
